import { Box, Button } from '@mui/material';
import { DataGridPro, DataGridProProps, GridColDef } from '@mui/x-data-grid-pro';
import React from 'react';

import { If } from 'app/components/if';
import { DescriptorData } from 'app/model/crowd/descriptor-data';
import { DataGridFormatters } from 'app/utils/data-grid-formatters';

interface DescriptorListGridProps extends Omit<DataGridProProps<DescriptorData>, 'columns'> {
    rows: DescriptorData[];
    markReviewed: (entity: DescriptorData) => void;
}

export const DescriptorListGrid: React.FunctionComponent<DescriptorListGridProps> = ({ markReviewed, ...props }) => {
    const statusColumn: GridColDef<DescriptorData> = {
        field: 'status',
        headerName: 'Status',
        valueFormatter: (params) => (0 === params.value ? 'New' : 'Reviewed'),
        renderCell: (params) => (
            <Box>
                {params.formattedValue}{' '}
                <If condition={1 !== params.value}>
                    <Button onClick={() => markReviewed(params.row)}>Done</Button>
                </If>
            </Box>
        ),
    };

    return <DataGridPro {...props} columns={[statusColumn, ...columns]} />;
};

const columns: Array<GridColDef<DescriptorData>> = [
    {
        field: 'id',
        headerName: 'ID',
        width: 150,
    },
    {
        field: 'descriptor',
        headerName: 'Descriptor',
        width: 150,
    },
    {
        field: 'merchant',
        headerName: 'Merchant',
        width: 150,
    },
    {
        field: 'notes',
        headerName: 'Notes',
        width: 150,
    },
    {
        field: 'userCreated',
        headerName: 'User Created',
        width: 200,
        valueFormatter: DataGridFormatters.usernameFormatter,
    },
    {
        field: 'dateCreated',
        headerName: 'Date Created',
        width: 200,
        valueFormatter: DataGridFormatters.dateTimeFormatter,
    },
    {
        field: 'dateEdited',
        headerName: 'Date Edited',
        width: 200,
        valueFormatter: DataGridFormatters.dateTimeFormatter,
    },
];
